import { render } from "./DigitalGiftCertificatePage.vue?vue&type=template&id=99db8d78"
import script from "./DigitalGiftCertificatePage.vue?vue&type=script&lang=js"
export * from "./DigitalGiftCertificatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__